import { Link } from "react-router-dom";

interface PlanBadgeProps {
  className?: string;
  studentCount: number;
  planLimit: number;
}

export function PlanBadge({
  className = "",
  studentCount,
  planLimit,
}: PlanBadgeProps) {
  const shouldShowBadge = studentCount >= planLimit;

  if (!shouldShowBadge) {
    return null;
  }

  return (
    <Link to="/settings" className="group relative">
      <div
        className={`w-2 h-2 lg:w-3 lg:h-3 rounded-full bg-red-500 ${className}`}
      />
      <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 lg:px-3 py-1 lg:py-2 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-50 translate-x-4">
        Upgrade your plan to add more students
      </div>
    </Link>
  );
}
